module.exports = __webpack_public_path__ + "static/media/mongodb.437b07a4.svg";